module.exports = __webpack_public_path__ + "media/flags/bd-29abbae7.svg";